import styled from 'styled-components'

import { fontFamily, fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Heading = styled.h2`
  font-family: ${fontFamily.CATAMARAN};
  font-weight: ${fontWeight.EXTRA};
  font-size: ${fontSize.LARGE_XXXL};
  color: ${color.GREYISH_BROWN};
`

export const TopPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2rem;

  ${media.desktop} {
    margin-bottom: unset;
    flex-direction: row;
  }
`

export const LinksWrap = styled.div`
  display: flex;
  align-items: center;
`

export const OuterLinkWrap = styled.div`
  & + & {
    margin-left: 2.4rem;
  }
`

export const NavigationLink = styled.span<{ isActive?: boolean }>`
  color: ${({ isActive }) => (isActive ? color.DUSTY_ORANGE : color.WARM_GREY)};
  font-family: ${fontFamily.CATAMARAN};
  font-weight: ${fontWeight.EXTRA};
  font-size: ${fontSize.LARGE_XL};
`

export const ContentWrapInner = styled.div`
  max-width: 96rem;
  margin: auto;
  padding: 0 2.4rem 2.4rem;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`
